import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

export type RadarSyncScope = "gabarito" | "all";

interface RadarSyncDialogProps {
  open: boolean;
  profileName: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: (scope: RadarSyncScope) => void;
}

export const RadarSyncDialog = ({
  open,
  profileName,
  loading,
  onClose,
  onConfirm,
}: RadarSyncDialogProps) => {
  const [scope, setScope] = useState<RadarSyncScope>("gabarito");

  useEffect(() => {
    if (open) setScope("gabarito");
  }, [open]);

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Sincronizar palavras-chave via Radar</DialogTitle>
      <DialogContent>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Escolha quais palavras de {profileName} serão pesquisadas.
        </Typography>
        <FormControl>
          <RadioGroup
            value={scope}
            onChange={(event) => setScope(event.target.value as RadarSyncScope)}
          >
            <FormControlLabel
              value="gabarito"
              control={<Radio />}
              label="Palavras do Gabarito (recomendado)"
            />
            <FormControlLabel
              value="all"
              control={<Radio />}
              label="Todas as palavras do perfil"
            />
          </RadioGroup>
        </FormControl>
        <Alert severity="info" sx={{ mt: 2 }}>
          As palavras serão enviadas em lotes seguros de até 20. Os resultados serão acrescentados
          automaticamente ao relatório acessado pelo cliente.
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={loading} color="inherit">
          Cancelar
        </Button>
        <Button variant="contained" onClick={() => onConfirm(scope)} disabled={loading}>
          {loading ? "Sincronizando..." : "Sincronizar com Radar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
